import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, Row } from 'antd';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField } from '../../../../../contextRedux/Company/CompanyModel';
import { RootState } from '../../../../../store';
import './ContactPersonsTab.css';

const ContactPersonsTab: FC = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const company = useSelector((state: RootState) => state.models.company);
  const contactPersons = useSelector((state: RootState) => state.models.company.contactPersons);

  useEffect(() => {
    const currentFormValues = form.getFieldValue('contactPersons');
    if (JSON.stringify(currentFormValues) !== JSON.stringify(contactPersons)) {
      form.setFieldsValue({ contactPersons });
    }
  }, [contactPersons, form]);

  const handleAddContactPerson = (addFn: any) => {
    const newContactPerson = {
      id: null,
      companyId: company.id,
      name: '',
      phone: '',
      email: '',
      isActive: true,
      role: '',
    };

    // Add to form list first
    addFn(newContactPerson);

    // Then update Redux state
    const updatedContactPersons = [...(contactPersons || []), newContactPerson];
    dispatch(updateField({ field: 'contactPersons', value: updatedContactPersons }));
  };

  const handleRemoveContactPerson = (index: number, removeFn: any) => {
    // Remove from form list first
    removeFn(index);

    // Then update Redux state
    const updatedContactPersons = contactPersons.filter((_: any, i: number) => i !== index);
    dispatch(updateField({ field: 'contactPersons', value: updatedContactPersons }));
  };

  const handleValuesChange = (_: any, allValues: any) => {
    const newValues = allValues.contactPersons;
    if (JSON.stringify(contactPersons) !== JSON.stringify(newValues)) {
      dispatch(updateField({ field: 'contactPersons', value: newValues }));
    }
  };

  return (
    <Form
      form={form}
      name='contactPersonsForm'
      onValuesChange={handleValuesChange}
      layout='vertical'
      className='contact-persons-form'
      initialValues={{ contactPersons }}
    >
      <Form.List name='contactPersons'>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <div key={field.key} className='contact-person-card'>
                <div className='contact-person-header'>
                  <span className='contact-person-number'></span>
                  <Button
                    type='text'
                    className='delete-button'
                    icon={<MinusCircleOutlined />}
                    onClick={() => handleRemoveContactPerson(index, remove)}
                  />
                </div>

                <Row gutter={[16, 16]} className='row'>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label='Nume'
                      name={[field.name, 'name']}
                      rules={[{ required: true, message: 'Introdu numele!' }]}
                    >
                      <Input placeholder='Introdu denumire' />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label='Telefon'
                      name={[field.name, 'phone']}
                      rules={[{ required: true, message: 'Introdu telefon!' }]}
                    >
                      <Input placeholder='Introdu telefon' />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]} className='row'>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label='Email'
                      name={[field.name, 'email']}
                      rules={[{ required: true, message: 'Introdu email!' }]}
                    >
                      <Input placeholder='Introdu email' />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label='Rol'
                      name={[field.name, 'role']}
                      rules={[{ required: true, message: 'Introdu rol!' }]}
                    >
                      <Input placeholder='Introdu rol' />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]} className='row'>
                  <Col xs={24}>
                    <div className='status-wrapper'>
                      <span className='status-label'>Status:</span>
                      <Form.Item name={[field.name, 'isActive']} valuePropName='checked' noStyle>
                        <Checkbox>{contactPersons[index].isActive ? 'Activ' : 'Inactiv'}</Checkbox>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </div>
            ))}

            <Form.Item className='add-contact-button'>
              <Button
                type='dashed'
                onClick={() => handleAddContactPerson(add)}
                style={{ width: '100%' }}
                icon={<PlusOutlined />}
              >
                Adaugă persoană de contact
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default ContactPersonsTab;
